(function () {
  var selector = '[data-monster-world]';

  function toArray(items) {
    return Array.prototype.slice.call(items || []);
  }

  function initialize(root) {
    if (!root || root.getAttribute('data-radio-rotator-ready') === 'true') return;

    var states = toArray(root.querySelectorAll('[data-mw-state]'));
    var status = root.querySelector('[data-mw-status]');
    if (states.length < 2) return;

    var intervalId = null;
    var hoverPaused = false;
    var focusPaused = false;
    var speed = Number(root.getAttribute('data-rotation-speed')) || 6000;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.setAttribute('data-radio-rotator-ready', 'true');

    function currentIndex() {
      for (var index = 0; index < states.length; index += 1) {
        if (states[index].checked) return index;
      }
      return 0;
    }

    function announceCurrent() {
      if (!status) return;
      var active = root.querySelector('.mw__art--main .mw__design--' + currentIndex());
      status.textContent = active ? active.getAttribute('alt') || '' : '';
    }

    function isPaused() {
      return hoverPaused || focusPaused || reducedMotion || document.hidden;
    }

    function updateLiveRegion() {
      if (status) status.setAttribute('aria-live', isPaused() ? 'polite' : 'off');
    }

    function stopRotation() {
      if (!intervalId) return;
      window.clearInterval(intervalId);
      intervalId = null;
    }

    function startRotation() {
      stopRotation();
      updateLiveRegion();
      if (!isPaused()) {
        intervalId = window.setInterval(function () {
          var nextIndex = (currentIndex() + 1) % states.length;
          states[nextIndex].checked = true;
        }, speed);
      }
    }

    for (var index = 0; index < states.length; index += 1) {
      states[index].addEventListener('change', function () {
        announceCurrent();
        startRotation();
      });
    }

    root.addEventListener('pointerenter', function () {
      hoverPaused = true;
      startRotation();
    });

    root.addEventListener('pointerleave', function () {
      hoverPaused = false;
      startRotation();
    });

    root.addEventListener('focusin', function () {
      focusPaused = true;
      startRotation();
    });

    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) {
        focusPaused = false;
        startRotation();
      }
    });

    document.addEventListener('visibilitychange', startRotation);
    startRotation();
  }

  function initializeAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(selector)) initialize(target);
    var roots = toArray(target.querySelectorAll(selector));
    for (var index = 0; index < roots.length; index += 1) initialize(roots[index]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
}());
